import Vue from "vue";
import { $http } from "@/utils/https";

import {
	DELETE_USER_TARIFF_LOADING,
	FRESH_USER_PERSONA_DATA,
	LOADING_USER_DATA,
	MOBILE_CHANGE_SHOW_MENU,
	REMOVE_USER_TARIFF_IN_LIST,
	SET_PREV_ROUTE,
	SET_PROFILE_ROUTES,
	REMOVE_PROFILE_ROUTE,
	SET_USER_DATA,
	SET_USER_TARIFF,
	SET_USER_TARIFF_LOADING,
	SET_USER_FREE_ACCESS_LOADING,
	SET_USER_FREE_ACCESS,
	UPDATE_USER_DATA_LOADING,
	USER_REMOVE_SOCIAL_PROVIDER,
	USER_UPDATE_DATA
} from "./types/mutation-types";

import {
	DELETE_USER_TARIFF,
	UPDATE_USER_TARIFF,
	PAYMENT_USER_TARIFF,
	GET_USER_DATA,
	GET_USER_TARIFF,
	GET_USER_FREE_ACCESS,
	UPDATE_USER_DATA
} from "./types/action-types";

//import { translationUtils } from "@/utils/translations";

const state = {
	user				: null,
	loadingUser			: false,
	updateUserLoading	: false,
	showMobileMenu		: false,
	userTariff			: [],
	userFreeAccess		: {},
	userTariffLoading	: false,
	prevRoute			: null,
	profileRoutes		: []
};

const getters = {
	user					: (state) => state.user,
	loadingUser				: (state) => state.loadingUser,
	updateUserLoading		: (state) => state.updateUserLoading,
	showMobileMenu			: (state) => state.showMobileMenu,
	userTariff				: (state) => state.userTariff,
	userFreeAccessLoading	: (state) => state.userFreeAccessLoading,
	userFreeAccess			: (state) => state.userFreeAccess,
	userTariffLoading		: (state) => state.userTariffLoading,
	prevRoute				: (state) => state.prevRoute,
	profileRoutes			: (state) => state.profileRoutes
};

const actions = {
	[GET_USER_DATA]			: async ({ state, commit }) => {
		if (state.loadingUser) {
			return;
		}
		
		try {
			commit(LOADING_USER_DATA, true);
			
			const response = await $http.get(
				`${process.env.VUE_APP_ROOT_USER}profile?include=permissions,setting,setting.timezone,countries,personalData,roles,socials`
			);
			
			console.log("GET_USER_DATA:\n");
			console.log(response.data.data);
			console.log("\n");
			
			commit(SET_USER_DATA, response.data.data);
			
			return response;
		} catch (e) {
			throw e;
		} finally {
			commit(LOADING_USER_DATA, false);
		}
	},
	[UPDATE_USER_DATA]		: async ({ commit }, payload) => {
		try {
			commit(UPDATE_USER_DATA_LOADING, true);
			
			const response = await $http.post("v1/users/update", payload);
			
			commit(SET_USER_DATA, response.data.data);
			
			return response;
		} catch (e) {
			throw e;
		} finally {
			commit(UPDATE_USER_DATA_LOADING, false);
		}
	},
	[GET_USER_TARIFF]		: async ({ commit }) => {
		try {
			commit(SET_USER_TARIFF_LOADING, true);
			
			// TODO: tmp off, before education materials service will be on
			const response = await $http.get(
				`${process.env.VUE_APP_ROOT_EDUCATION}user/tariffs?include=tariff,payment`
			);
			
			commit(SET_USER_TARIFF, response.data.data);
			
			return response.data.data;
		} catch (e) {
			throw e;
		} finally {
			commit(SET_USER_TARIFF_LOADING, false);
		}
	},
	[GET_USER_FREE_ACCESS]	: async ({ commit }) => {
		try {
			commit(SET_USER_FREE_ACCESS_LOADING, true);
			
			const response = await $http.get(
				`${process.env.VUE_APP_ROOT_EDUCATION}user/tariffs/free`
			);
			
			commit(SET_USER_FREE_ACCESS, response.data.data);
			
			return response.data.data;
		} catch (e) {
			throw e;
		} finally {
			commit(SET_USER_FREE_ACCESS_LOADING, false);
		}
	},
	[DELETE_USER_TARIFF]	: async ({ state, commit, dispatch }, payload) => {
		try {
			commit(DELETE_USER_TARIFF_LOADING, {
				...payload,
				status: true,
			});
			
			const response = await $http.delete(
				`${process.env.VUE_APP_ROOT_EDUCATION}user/tariffs/${payload.id}?include=tariff,payment`
			);
			
			if (
				response.status == 200 &&
				response.data && 
				true
				//response.data.data.count == 1
			) {
				/*
				var userTariff = [];
				
				for (let i = 0; i < state.userTariff.length; i++) {
					if (state.userTariff[i].id == payload.id) {
						userTariff.push({
							...state.userTariff[i],
							isConnected: false,
						});
					} else {
						userTariff.push({
							...state.userTariff[i],
						});
					}
				}
				
				commit(SET_USER_TARIFF, userTariff);
				
				userTariff = [];
				*/
				
				setTimeout(() => {
					dispatch(GET_USER_TARIFF);
				}, 5000);
				
				setTimeout(() => {
					dispatch(GET_USER_TARIFF);
					
					commit(DELETE_USER_TARIFF_LOADING, {
						...payload,
						status: false,
					});
				}, 10000);
			}
			
			// commit(GET_USER_TARIFF);
			// commit(REMOVE_USER_TARIFF_IN_LIST, payload);
		} catch (e) {
			commit(DELETE_USER_TARIFF_LOADING, {
				...payload,
				status: false,
			});
			
			throw e;
		} finally {
			
		}
	},
	[UPDATE_USER_TARIFF]	: async ({ state, commit, dispatch }, payload) => {
		try {
			commit(DELETE_USER_TARIFF_LOADING, {
				...payload,
				status: true
			});
			
			//console.log('payload:', payload);
			
			const response = await $http.post(
				`${process.env.VUE_APP_ROOT_EDUCATION}user/tariffs/${payload.id}`
			);
			
			if (response.status == 200 && response.data && response.data.data.id) {
				if (response.data.data.createLink) {
					commit(DELETE_USER_TARIFF_LOADING, {
						...payload,
						status	: false
					});
					
					return response.data.data;
				} else {
					/*
					var userTariff = [];
					
					for (let i = 0; i < state.userTariff.length; i++) {
						if (state.userTariff[i].id == payload.id) {
							userTariff.push({
								...state.userTariff[i],
								isConnected: response.data.data.isConnected == true,
							});
						} else {
							userTariff.push({
								...state.userTariff[i],
							});
						}
					}
					
					commit(SET_USER_TARIFF, userTariff);
					
					userTariff = [];
					*/
					
					setTimeout(() => {
						dispatch(GET_USER_TARIFF);
					}, 5000);
					
					setTimeout(() => {
						dispatch(GET_USER_TARIFF);
						
						commit(DELETE_USER_TARIFF_LOADING, {
							...payload,
							status	: false
						});
					}, 10000);
					
					return null;
				}
			}
			
			// commit(GET_USER_TARIFF);
			// commit(REMOVE_USER_TARIFF_IN_LIST, payload);
		} catch (e) {
			commit(DELETE_USER_TARIFF_LOADING, {
				...payload,
				status	: false
			});
			
			throw e;
		} finally {
			
		}
	},
	[PAYMENT_USER_TARIFF]	: async ({ state, commit, dispatch }, payload) => {
		try {
			commit(DELETE_USER_TARIFF_LOADING, {
				...payload,
				status: true,
			});
			
			const response = await $http.post(
				`${process.env.VUE_APP_ROOT_PARTNER}subscribe`,
				payload
			);
			
			if (response.status == 200 && response.data && response.data.url) {
				commit(DELETE_USER_TARIFF_LOADING, {
					...payload,
					status: false,
				});
				
				return response.data;
			}
			
			// commit(GET_USER_TARIFF);
			// commit(REMOVE_USER_TARIFF_IN_LIST, payload);
		} catch (e) {
			throw e;
		} finally {
			commit(DELETE_USER_TARIFF_LOADING, {
				...payload,
				status: false,
			});
		}
	},
};

const mutations = {
	[SET_USER_DATA](state, data) {
		const originCountry = data.countries.data.find((e) => e.type === "origin");
		const defaultCountry = data.countries.data.find((e) => e.type === "default");
		
		data.originCountry = originCountry ? originCountry.country.data : null;
		data.defaultCountry = defaultCountry.country.data;
		
		data.languageInterface = {
			value: data.setting.data.interfaceLanguage,
			name: "",
		};
		
		data.formatsDate = { id: 2, name: "дд . мм . гггг – 24 часа" };
		
		const timezone = data.setting.data.timezone.data.hasOwnProperty("id")
			? data.setting.data.timezone.data
			: null;
		
		if (timezone) {
			data.timeZone = {
				name: timezone.name,
				id: timezone.id,
			};
		} else {
			data.timeZone = {
				name: "",
				id: "",
			};
		}
		
		data.setting.data.coursesLanguages = data.setting.data.coursesLanguages.map(
			(e) => {
				return {
					slug: e,
				};
			}
		);
		
		state.user = data;
		
		//   translationUtils.setInterfaceLanguage(data.languageInterface.value)
		//   localStorage.setItem('interface_language', data.languageInterface.value)
	},
	[LOADING_USER_DATA](state, status) {
		state.loadingUser = status;
	},
	[USER_UPDATE_DATA](state, params) {
		if (params.hasOwnProperty("interfaceLanguage")) {
			state.user.languageInterface.value = params.interfaceLanguage;
		}
		
		if (params.hasOwnProperty("provider")) {
			state.user.socials.data.push(params);
		}
	},
	[USER_REMOVE_SOCIAL_PROVIDER](state, params) {
		const index = state.user.socials.data.findIndex((e) => e.id === params.id);
		
		Vue.delete(state.user.socials.data, index);
	},
	[UPDATE_USER_DATA_LOADING](state, status) {
		state.updateUserLoading = status;
	},
	[FRESH_USER_PERSONA_DATA](state, data) {
		state.user.personalData.data = data;
	},
	[MOBILE_CHANGE_SHOW_MENU](state, status) {
		state.showMobileMenu = status;
	},
	[SET_USER_TARIFF](state, data) {
		state.userTariff = data.map((e) => {
			return {
				...e,
				loading: false
			};
		});
	},
	[SET_USER_TARIFF_LOADING](state, status) {
		state.userTariffLoading = status;
	},
	[SET_USER_FREE_ACCESS_LOADING](state, status) {
		state.userFreeAccessLoading = status;
	},
	[SET_USER_FREE_ACCESS](state, data) {
		state.userFreeAccess = data;
	},
	[DELETE_USER_TARIFF_LOADING](state, params) {
		const { id, status } = params;
		const index = state.userTariff.findIndex((e) => e.id === id);
		
		if (index >= 0 && index in state.userTariff) {
			state.userTariff[index].loading = status;
			
			//Vue.set(state.userTariff[index], "loading", status);
		}
	},
	[REMOVE_USER_TARIFF_IN_LIST](state, params) {
		const { id } = params;
		const index = state.userTariff.findIndex((e) => e.id === id);
		
		Vue.delete(state.userTariff, index);
	},
	[SET_PREV_ROUTE](state, prevRoute) {
		state.prevRoute = prevRoute;
	},
	[SET_PROFILE_ROUTES](state, value) {
		state.profileRoutes = [...state.profileRoutes, value];
	},
	[REMOVE_PROFILE_ROUTE](state, value) {
		const updatedRoutes = state.profileRoutes.splice(
			0,
			state.profileRoutes.length - 2
		);
		
		state.profileRoutes = updatedRoutes;
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};
